module.exports = __webpack_public_path__ + "static/img/5.5682291.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/zh/5.png
// module id = 3F2S
// module chunks = 0